import { Box } from '@chakra-ui/react';
import { ChatMessageEntityLinkType } from '@texas/api/endpoints/chat/chatApi';
import { aiEvents } from '../events';
import { CustomElement } from '../extensions';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { customersApi } from '@texas/api/endpoints/customersApi';
import { useEffect } from 'react';
import { blinkAnimation } from '@texas/resources/animations/animations';
import { randomIdentifier } from '@texas/utils/helpers/commonHelpers';

const prefix = 'How many pending product approvals are there for customer ';

export function CustomerPendingPaPrompt({ id }: { id: number | null }) {
  const { refetch, data, loading, set } = useApiResource(customersApi.getSlim);

  useEffect(() => {
    if (id) {
      refetch(id);
    } else {
      set(null);
    }
  }, [id, refetch, set]);

  return (
    <Box
      cursor="pointer"
      opacity={0.6}
      animation={loading ? blinkAnimation() : undefined}
      _hover={{ opacity: 1, textDecoration: 'underline' }}
      onClick={() => {
        aiEvents.updateMessage.dispatch(
          slateElement(data ? { id: data.id, name: data.name } : null),
        );
      }}
    >
      {data ? `${prefix} ${data.name}` : `${prefix} @Customer`}
    </Box>
  );
}

function slateElement(
  data: { name: string; id: number } | null,
): CustomElement[] {
  if (data) {
    return [
      {
        type: 'paragraph',
        children: [
          {
            text: prefix,
          },
          {
            type: 'entity-value',
            entityId: data.id,
            entityType: ChatMessageEntityLinkType.Customer,
            label: data.name,
            identifier: randomIdentifier(),
            children: [
              {
                text: '',
              },
            ],
          },
          {
            text: '',
          },
        ],
      },
    ];
  }

  return [
    {
      type: 'paragraph',
      children: [
        {
          text: prefix,
        },
        {
          type: 'entity-category',
          entityType: ChatMessageEntityLinkType.Customer,
          children: [
            {
              text: '',
            },
          ],
        },
        {
          text: '',
        },
      ],
    },
  ];
}
